import { useState } from 'react';
import { Toggle, Dropdown, Tooltip } from '@ets/design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from '_common/hooks';
import { openModal } from '_common/modals/ModalsSlice';

type FooterHelpProps = {
  resetOnboarding: () => void;
};

const FooterHelp = ({ resetOnboarding }: FooterHelpProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenAboutModal = () => {
    dispatch(openModal('AboutModal'));
  };
  return (
    <Dropdown.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dropdown.Trigger>
        <Tooltip
          content={intl.formatMessage({ id: 'HELP_AND_SUPPORT' })}
          placement="left"
          visible={!isOpen}
          testId="help"
        >
          <span>
            <Toggle
              size="m"
              variant="link"
              iconProps={{
                icon: 'circle-question',
              }}
              isToggled={isOpen}
              testId="help"
              onClick={() => setIsOpen(!isOpen)}
            />
          </span>
        </Tooltip>
      </Dropdown.Trigger>
      <Dropdown.Content align="end" testId="help-support-dropdown">
        <Dropdown.Item onClick={handleOpenAboutModal} testId="help-open-about-modal">
          <FormattedMessage id="ABOUT_DODOC" />
        </Dropdown.Item>
        <Dropdown.Item onClick={resetOnboarding} testId="help-reset-onboarding">
          <FormattedMessage id="RESET_ONBOARDING" />
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown.Root>
  );
};

export default FooterHelp;
